import { render, staticRenderFns } from "./SelectGuardian.vue?vue&type=template&id=f14ad488&scoped=true"
import script from "./SelectGuardian.vue?vue&type=script&lang=js"
export * from "./SelectGuardian.vue?vue&type=script&lang=js"
import style0 from "./SelectGuardian.vue?vue&type=style&index=0&id=f14ad488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14ad488",
  null
  
)

export default component.exports